import { Input, Button } from '@cb/apricot-react';
import { ChangeEventHandler, FC, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Dropdown } from 'src/components';
import { countryOptions } from 'src/constants';
import { TSchoolSearchCondition } from 'src/types';

interface SchoolSearchFormProps {
  init?: TSchoolSearchCondition;
  onSubmit: (form: TSchoolSearchCondition) => void;
}

const SchoolSearchForm: FC<SchoolSearchFormProps> = ({ init, onSubmit }) => {
  const [search, setSearch] = useState(init?.OrgName || '');
  const [country, setCountry] = useState(init?.Country || '');
  const [zipCode, setZipCode] = useState(init?.Zip || '');
  const [valid, setValid] = useState(false);

  const getData = () => {
    return {
      Country: country.trim(),
      Zip: zipCode.trim(),
      OrgName: search.trim()
    };
  };

  const handleChangeCountry = (country: string) => {
    setCountry(country);
  };

  const handleChangeSearch: ChangeEventHandler<HTMLInputElement> = (event) => {
    setSearch(event.target.value);
  };

  const handleChangeZipCode: ChangeEventHandler<HTMLInputElement> = (event) => {
    setZipCode(event.target.value);
  };

  useEffect(() => {
    if (!search.length || !country.length || (zipCode.length && zipCode.length < 5)) {
      setValid(false);
    } else {
      setValid(true);
    }
  }, [search, country, zipCode]);

  const submit = () => {
    if (valid)
      onSubmit(getData());
  };

  return (
    <div style={{ width: '100%' }} className="cb-card cb-card-event">

      <div className="cb-card-content">
        <div style={{ marginBottom: '20px' }}>
          <div className="cb-card-desc">
            <Dropdown
              floating={false}
              label="Select a Country *"
              labelNoValue="Select One"
              onChange={handleChangeCountry}
              value={country}
              values={countryOptions}
            />
          </div>

          <div className="cb-card-desc cb-margin-top-16">
            <Input
              floating={false}
              label="Search for your organization by name, address, city, or state code *"
              placeholder="College Board"
              onChange={handleChangeSearch}
              value={search}
            />
          </div>

          {country === 'US' && (
            <div className="cb-card-desc cb-margin-top-16">
              <Input floating={false} label="Zip Code" onChange={handleChangeZipCode} value={zipCode} />
            </div>
          )}

        </div>
        <Button disabled={!valid} onClick={() => { submit(); }}>Submit</Button>
      </div>
    </div>
  );
};

export default SchoolSearchForm;
